
import NrIconButton from '../NrIconButton/nr-icon-button.vue'
import NrTooltip from '../NrTooltip/NrTooltip.vue'
import NrFormInput from '../NrFormInput/nr-form-input.vue'

export default {
  components: { NrIconButton, NrFormInput, NrTooltip },
  props: {
    resultCount: {
      type: Number,
      default: 0
    },
    totalCount: {
      type: Number,
      default: 0
    },
    columns: {
      type: Array,
      default: () => {
        return []
      }
    },
    enableColumnFilter: {
      type: Boolean,
      default: false
    },
    tableHeaderTitle: {
      type: String,
      default: 'results'
    },
    tableHeaderTitleTooltip: {
      type: String
    }
  },
  data() {
    return { filterToggled: false, columnFilterToggled: false }
  },
  methods: {
    handleSidebarToggle() {
      this.filterToggled = !this.filterToggled
      this.$emit('handleSidebarToggle', this.filterToggled)
    },
    toggleColumnFilter() {
      this.columnFilterToggled = !this.columnFilterToggled
    },
    updateColumnValue(column, columnValue) {
      this.$emit('toggleColumnState', { column, columnValue })
    }
  }
}
